var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedAgent10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.741 0L18.3864 7.35456L20.1025 9.07063L24.5152 4.65789V20.8379C24.5152 26.9667 19.6122 31.8698 13.4834 31.8698C11.5221 31.8698 9.68351 31.3795 8.21259 30.5214C8.7029 30.644 9.1932 30.644 9.80608 30.644C15.1994 30.644 19.6122 26.2313 19.6122 20.8379C19.6122 15.4446 15.1994 11.0318 9.80608 11.0318C4.41274 11.0318 0 15.4446 0 20.8379C0 28.3151 6.00623 34.3213 13.4834 34.3213C20.9605 34.3213 26.9667 28.3151 26.9667 20.8379V4.65789L31.3795 9.07063L33.0955 7.35456L25.741 0ZM2.45152 21.5734V20.8379C2.45152 16.7929 5.76107 13.4834 9.80608 13.4834C13.8511 13.4834 17.1606 16.7929 17.1606 20.8379C17.1606 24.8829 13.8511 28.1925 9.80608 28.1925C6.00623 28.1925 2.81925 25.2507 2.45152 21.5734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedAgent10);
export default __webpack_public_path__ + "static/media/icon-red-agent-10.99c09fd77ad8b2a31797a354c39a7ed9.svg";
export { ForwardRef as ReactComponent };